import * as allProducts from '@/mocks/data/catalogue/products/list'
import * as machines from '@/mocks/data/machines/list'

import { PaymentMethod, Sale } from '@/types/transactions/sale'

export const sale1: Sale = {
    id: 1,
    date_time: '2025-06-29T21:58:08Z',
    machine: machines.machine1,
    total: 3.7,
    payment_method: PaymentMethod.enum.KONVIVES,
    card_type: 'VISA',
    contact_less_card: true,
    participation: 0,
    products: [
        {
            id: 101,
            product: allProducts.product1,
        },
        {
            id: 102,
            product: allProducts.product2,
        },
        {
            id: 103,
            product: allProducts.product3,
        },
    ],
    orders: [1, 2, 3],
    menus: [],
    discounts: [],
    dispute_sale: [],
}

export const sale2: Sale = {
    id: 2,
    date_time: '2025-06-28T10:47:52Z',
    machine: machines.machine1,
    total: 2.5,
    payment_method: PaymentMethod.enum.CREDIT_CARD,
    card_type: 'MASTERCARD',
    contact_less_card: true,
    participation: 0,
    products: [],
    orders: [1, 2],
    menus: [],
    discounts: [],
    dispute_sale: [],
}

export const sale3: Sale = {
    id: 3,
    date_time: '2025-06-28T09:58:05Z',
    machine: machines.machine1,
    total: 2,
    payment_method: PaymentMethod.enum.PRIVATE_CARD,
    card_type: 'VISA',
    contact_less_card: false,
    participation: 0,
    products: [
        {
            id: 301,
            product: allProducts.product2,
        },
        {
            id: 302,
            product: allProducts.product3,
        },
    ],
    orders: [1],
    menus: [],
    discounts: [],
    dispute_sale: [],
}
